export default __webpack_public_path__ + "images/8bb4cfe7ba2cf96a86cbeaef5252e83c.svg";